interface ICheckoutGateInput {
  hasPricing: boolean;
  benefitQuoteBlocked: boolean;
  appliedCoupon?: string;
  couponErrorMessage?: string;
}

/** A supplied code is authoritative input: an error can never degrade to full price. */
export const isJobCheckoutBlocked = ({
  hasPricing,
  benefitQuoteBlocked,
  appliedCoupon,
  couponErrorMessage,
}: ICheckoutGateInput): boolean => (
  !hasPricing
  || benefitQuoteBlocked
  || Boolean(appliedCoupon && couponErrorMessage)
);

/** The selected finite benefit is authoritative for the amount due in the footer. */
export const getJobCheckoutTotal = (
  listingType: number,
  standardPrice?: number,
  featuredPrice?: number,
  benefitFinalAmount?: number,
): number | undefined => benefitFinalAmount
  ?? (listingType === 1 ? standardPrice : featuredPrice);
